import { trackerApi } from "../api/TrackerApi";
import { useMutationCommand } from "../components/helpers/queryHelper";

export interface LoginDto {
    username: string,
    password: string
}

export interface AppUserDto {
    username: string,
    token: string,
    tokenExpireTime: Date,
    isAdmin: boolean,
    isContributor: boolean
}

const login = async (props: LoginDto) => {


    let param: LoginDto = {
        ...props
    }

    let appUser: AppUserDto = await trackerApi.callServicePost("/authentication/login", param)

    return appUser;
}

export const useMutationLogin = () => {


    let mutation = useMutationCommand<LoginDto, AppUserDto>(login, "authentication")

    return mutation;
}